"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/checkbox/style/css");

var _checkbox = _interopRequireDefault(require("antd/es/checkbox"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireDefault(require("react"));

var _ = _interopRequireWildcard(require("lodash"));

var _uuid = _interopRequireDefault(require("uuid"));

require("../activity.scss");

var _DynamicOptionItems = _interopRequireDefault(require("../options/DynamicOptionItems"));

var _ActivityFormContainer = require("../ActivityFormContainer");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const defaultOption = {
  text: '',
  uuid: '',
  points: 0,
  isCorrect: false,
  correctPosition: undefined,
  feedback: undefined
};

const QuizQuestion = props => {
  const {
    question,
    onTextChange,
    updateQuestion,
    disabled
  } = props;
  const {
    id,
    text,
    options,
    randomizeOptions,
    uuid
  } = question;

  const onRandomizeOptions = e => {
    question.randomizeOptions = e.target.checked;
    updateQuestion(question);
  };

  const updateOption = (option, index) => {
    if (options) {
      options[index] = option;
      updateQuestion(question);
    }
  };

  const addOption = () => {
    const updatedQuestion = _.cloneDeep(question);

    const newOption = _.cloneDeep(defaultOption);

    newOption.uuid = (0, _uuid.default)();

    if (!updatedQuestion.options) {
      updatedQuestion.options = [newOption];
    } else {
      updatedQuestion.options[updatedQuestion.options.length] = newOption;
    }

    updateQuestion(updatedQuestion);
  };

  const removeOption = index => {
    let i = 0;
    question.options = options ? options.filter(o => {
      return index !== i++;
    }) : [];
    updateQuestion(question);
  };

  const validateQuizQuestion = (rule, value) => {
    try {
      if (!options || options.length === 0) {
        throw new Error('Quiz questions must have at least one option');
      }

      if (options === null || options === void 0 ? void 0 : options.some(o => o.text.length == 0)) {
        throw new Error('Question options must have text');
      }

      if (!(options === null || options === void 0 ? void 0 : options.some(o => o.isCorrect))) {
        throw new Error('Quiz questions need at least one correct option defined');
      }

      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    }
  };

  return /*#__PURE__*/_react.default.createElement(Item, {
    key: `question-${id || uuid}`,
    name: `question-${id || uuid}`,
    rules: [{
      required: true,
      validator: validateQuizQuestion
    }]
  }, /*#__PURE__*/_react.default.createElement(Item, {
    key: `question-text-${id || uuid}`,
    name: `question-text-${id || uuid}`,
    initialValue: text,
    rules: [{
      required: true,
      message: 'Please add question text.'
    }]
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    spellCheck: true,
    disabled: disabled,
    placeholder: "Question text",
    onChange: onTextChange
  })), /*#__PURE__*/_react.default.createElement(_checkbox.default, {
    disabled: disabled,
    checked: randomizeOptions,
    onChange: onRandomizeOptions
  }, "Randomize answer options"), /*#__PURE__*/_react.default.createElement(_DynamicOptionItems.default, {
    disabled: disabled,
    options: options || [],
    typeId: _ActivityFormContainer.Type.quiz,
    updateOption: updateOption,
    addOption: addOption,
    removeOption: removeOption
  }));
};

var _default = QuizQuestion;
exports.default = _default;